import { z } from "zod";

import { zSchema as zMetaSchema } from "./meta";

function zSchema<Item extends z.ZodSchema, More extends z.ZodSchema>(item: Item, more: More) {
  return z.object({
    items: z.array(item),
    meta: zMetaSchema,
    more,
  });
}

type Schema<Item extends z.ZodSchema, More extends z.ZodSchema> = z.infer<
  ReturnType<typeof zSchema<Item, More>>
>;

export { zSchema };
export type { Schema };
